var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5939_6971)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5939_6971)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5939_6971)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FFEEB3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.2222,
    y: 46.8889,
    width: 25.3333,
    height: 6.44444,
    rx: 3.22222,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5939_6971)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.779,
    y: 72.3028,
    width: 48.2222,
    height: 51.1111,
    rx: 24.1111,
    transform: "rotate(-16 19.779 72.3028)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7777,
    y: 59.1111,
    width: 13.5556,
    height: 6.44444,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1111,
    y: 58.7778,
    width: 12.8889,
    height: 8.88889,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6666,
    y: 29.9999,
    width: 20.4444,
    height: 32.2222,
    rx: 10.2222,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 40.3333H41.778L40 44.5561V40.3333Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7778 40.3333H57.9998L59.7778 44.5561V40.3333Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_5939_6971",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7477 67.4443C61.3107 70.9031 56.1683 73.633 49.8889 73.633C43.6459 73.633 38.5267 70.9347 38.0382 67.5044C29.6758 69.8994 23.5557 77.6018 23.5557 86.7337V101.845H76.4446V86.7336C76.4446 77.5239 70.2196 69.7682 61.7477 67.4443Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7477 67.4443C61.3107 70.9031 56.1683 73.633 49.8889 73.633C43.6459 73.633 38.5267 70.9347 38.0382 67.5044C29.6758 69.8994 23.5557 77.6018 23.5557 86.7337V101.845H76.4446V86.7336C76.4446 77.5239 70.2196 69.7682 61.7477 67.4443Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7477 67.4443L61.924 66.8014L61.1826 66.598L61.0863 67.3607L61.7477 67.4443ZM38.0382 67.5044L38.6982 67.4104L38.5903 66.6528L37.8546 66.8635L38.0382 67.5044ZM23.5557 101.845H22.889V102.511H23.5557V101.845ZM76.4446 101.845V102.511H77.1112V101.845H76.4446ZM61.0863 67.3607C60.9071 68.7792 59.7353 70.1774 57.6995 71.2453C55.685 72.3021 52.9391 72.9663 49.8889 72.9663V74.2997C53.1181 74.2997 56.0832 73.5989 58.3189 72.4261C60.5335 71.2643 62.1513 69.5682 62.4091 67.5279L61.0863 67.3607ZM49.8889 72.9663C46.8564 72.9663 44.1247 72.3099 42.1132 71.2636C40.0808 70.2064 38.8989 68.8198 38.6982 67.4104L37.3782 67.5984C37.666 69.6193 39.2879 71.2969 41.498 72.4465C43.729 73.607 46.6783 74.2997 49.8889 74.2997V72.9663ZM24.2223 86.7337C24.2223 77.9072 30.1377 70.4606 38.2217 68.1453L37.8546 66.8635C29.2139 69.3382 22.889 77.2964 22.889 86.7337H24.2223ZM24.2223 101.845V86.7337H22.889V101.845H24.2223ZM76.4446 101.178H23.5557V102.511H76.4446V101.178ZM75.7779 86.7336V101.845H77.1112V86.7336H75.7779ZM61.5713 68.0872C69.7611 70.3337 75.7779 77.8319 75.7779 86.7336H77.1112C77.1112 77.216 70.6781 69.2026 61.924 66.8014L61.5713 68.0872Z",
    fill: "#111111",
    mask: "url(#path-11-inside-1_5939_6971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2689 33.5926L59.2824 33.6195L59.3004 33.6435C59.8826 34.4189 60.2527 34.9544 60.5202 35.5205C60.7856 36.0822 60.957 36.6895 61.1163 37.6122L61.1184 37.6244L61.1214 37.6363C61.443 38.9226 61.4448 40.5899 61.4448 41.5555C61.4448 42.3023 61.2384 49.3712 61.1503 52.3505C61.1232 53.2693 61.5315 54.1427 62.2497 54.713H60.141L60.1594 45.4326V45.4319V44.664V44.0625L59.6493 44.3814C58.8699 44.8687 58.225 45.1565 57.5068 45.326C56.7844 45.4964 55.9715 45.5512 54.8468 45.5515C52.9708 45.4634 51.3024 44.2808 50.1416 42.7098C49.2219 41.4653 47.8775 40.3828 46.238 40.3066L40.5715 40.0434C40.2627 40.029 40.0016 40.2695 39.9905 40.5785L39.869 43.977L39.869 43.977L39.8689 43.9801L39.5818 54.8424H37.9895C37.959 54.8424 37.9412 54.8337 37.9292 54.8245C37.9152 54.8137 37.9023 54.7964 37.895 54.7739C37.8876 54.7514 37.8878 54.7298 37.8927 54.7128C37.8969 54.6983 37.9061 54.6807 37.9307 54.6627C38.5453 54.2122 38.9 53.489 38.88 52.7272L38.5561 40.3683C38.6848 37.2186 39.9183 34.333 42.241 32.2009L42.241 32.2009L42.2429 32.1992C43.184 31.3217 44.2508 30.6314 45.3813 30.1285L45.5247 30.0735C48.4147 28.965 51.604 28.917 54.526 29.9378C56.3352 30.6875 57.9628 31.9341 59.2201 33.495L59.2689 33.5926Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.666667
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 5.75,
    width: 78.5,
    height: 78.5,
    rx: 39.25,
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5939_6971",
    x: 0.909091,
    y: 0.454545,
    width: 98.1818,
    height: 98.1818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.54545
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.54545
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5939_6971"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5939_6971",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5939_6971"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5939_6971"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5939_6971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.8889,
    height: 71.1111,
    fill: "white",
    transform: "translate(25.5557 10.3334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric06);
export default __webpack_public_path__ + "static/media/Generic 06.4d6bbf0735616a9ad4f81d03bab57298.svg";
export { ForwardRef as ReactComponent };